import DtcEditComponent from "../../../../antd/dtcs/TATMappings/DtcEdit"

const DtcEdit = () => {
  return <DtcEditComponent />
}

export default DtcEdit
